import "moment/min/locales";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import notifications_card from "../../assets/images/notifications_card.png";
import notifications_list from "../../assets/images/notifications_list.png";
import notifications_tile from "../../assets/images/notifications_tile.png";
import { PresentationType, ViewType } from "../../redux/alerts";
import { IAppState } from "../../redux/types";

import { useTranslation } from "react-i18next";
import { useSwipeable } from "react-swipeable";
import status_card from "../../assets/images/status_card.png";
import status_list from "../../assets/images/status_list.png";
import status_tile from "../../assets/images/status_tile.png";

const getSrc = (view, presentation) => {
  switch (view) {
    case ViewType.Notification: {
      switch (presentation) {
        case PresentationType.Cards:
          return notifications_card;
        case PresentationType.List:
          return notifications_list;
        case PresentationType.Tile:
          return notifications_tile;
      }
      break;
    }
    case ViewType.Status: {
      switch (presentation) {
        case PresentationType.Cards:
          return status_card;
        case PresentationType.List:
          return status_list;
        case PresentationType.Tile:
          return status_tile;
      }
      break;
    }
  }
};

const ChooseView = ({
  viewType,
  onSave,
}: {
  viewType: ViewType;
  onSave?: (view: ViewType, presentation: PresentationType) => void;
}): JSX.Element => {
  const { presentation } = useSelector(
    (state: IAppState) => state.alerts.settings
  );
  const [chosenPresentation, setchosenPresentation] = useState(presentation);
  const [saveBeforeMode, setsaveBeforeMode] = useState(false);
  const { t } = useTranslation("comon");
  const handlers = useSwipeable({
    onSwipedRight: () => {
      if (chosenPresentation !== presentation) setsaveBeforeMode(true);
      else onSave(viewType, presentation);
    },
  });
  return (
    <div className="choose-view" {...handlers}>
      {!saveBeforeMode ? (
        <>
          <img
            alt=""
            src={getSrc(viewType, chosenPresentation)}
            width={98}
            height={98}
            className="choose-view-card"
          />
          <div
            className="flex-between"
            // style={{ justifyContent: "space-around" }}
          >
            <button
              className={`btn btn-icon ${
                chosenPresentation === PresentationType.Cards ? "primary" : ""
              } btn-choose-view`}
              onClick={() => setchosenPresentation(PresentationType.Cards)}
            >
              <i className="icon-card" />
            </button>
            <button
              className={`btn btn-icon ${
                chosenPresentation === PresentationType.Tile ? "primary" : ""
              } btn-choose-view`}
              onClick={() => setchosenPresentation(PresentationType.Tile)}
            >
              <i className="icon-tiles" />
            </button>
            <button
              className={`btn btn-icon ${
                chosenPresentation === PresentationType.List ? "primary" : ""
              } btn-choose-view`}
              onClick={() => setchosenPresentation(PresentationType.List)}
            >
              <i className="icon-list" />
            </button>
          </div>
          <div className="flex-column flex-center flex-column-4">
            <p className="like-btn" style={{ marginTop: "16px" }}>
              {viewType === ViewType.Notification
                ? t("labels.NView")
                : t("labels.SView")}
            </p>
            <p style={{ marginTop: "3px" }}>
              {viewType === ViewType.Notification
                ? t("labels.NViewExpl")
                : t("labels.SViewExpl")}
            </p>
          </div>
          <div
            className="separator"
            style={{ marginTop: "16px", marginBottom: "10px" }}
          ></div>
          <button
            className="btn primary save-view"
            onClick={() => onSave(viewType, chosenPresentation)}
          >
            {t("buttons.Save")}
          </button>
        </>
      ) : (
        <>
          <p>{t("state.closeNoSave")}?</p>
          <button
            className="btn primary with-icon action-button save-view"
            onClick={() => onSave(viewType, chosenPresentation)}
          >
            <i className="icon-feedback-done"></i>
            {t("state.saveBefore")}
          </button>
          <button
            style={{ marginTop: "10px" }}
            className="btn secondary with-icon action-button save-view"
            onClick={() => onSave(viewType, presentation)}
          >
            <i className="icon-close"></i>
            {t("state.closeNoSave")}
          </button>
          <button
            style={{ marginTop: "10px" }}
            className="btn secondary with-icon action-button save-view"
            onClick={() => setsaveBeforeMode(false)}
          >
            <i className="icon-edit"></i>
            {t("state.keepEdit")}
          </button>
        </>
      )}
    </div>
  );
};

export default React.memo(ChooseView);
